import {ref} from 'vue'
import {defineStore} from 'pinia'
import { useAuthClient } from '@/stores/auth-store.ts'

const { get, post } = useAuthClient();

export const useMessageStore = defineStore('message', () => {
  const messages = ref<Array<any>>([])

  async function getMessages() {
    try {
      const response = await get('/rpc/api/messages')
      if (!response.ok) {
        console.error(`Error: ${response.status}`)
      } else {
        messages.value = await response.json()
      }
    } catch (err) {
      console.log(err);
    }
  }

  getMessages();
  window.addEventListener('auth:connected', () => { void getMessages(); });

  async function addMessage(message: string) {
    messages.value.push({
      message: message,
      type: 'MINE'
    });

    messages.value.push({
      type: 'PROCESSING',
    });

    const extracted = await extractInfo(message);
    messages.value[messages.value.length - 1] = {
      // message: extracted.title + " : " + extracted.edited,
      message: extracted,
      type: 'AI'
    };
    console.log('Extracted:', extracted);
  }

  async function createEventFromText(message: string) {
    return await extractInfo(message);
  }

  async function extractInfo(message: string) {
    try {
      const response = await post('/rpc/api/message', { message })
      if (!response.ok) {
        // throw new Error(`Error: ${response.status}`)
        console.error(`Error: ${response.status}`)
      }
      const event = await response.json();
      // return {metadata: event}
      return event;
    } catch (err) {
      console.log(err);
    }
  }

  return { messages, addMessage, createEventFromText }
})
